import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_PAYMENT_SESSION_ID: createAsyncMutation('GET_PAYMENT_SESSION_ID'),
    IS_STORE_DISABLED: createAsyncMutation('IS_STORE_DISABLED')
}

const payment = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getPaymentSessionId(store, orderId) {
            let url = api.payment + 'Session'
            if (orderId) {
                url += '?orderId=' + orderId
            }
            return doAsyncGet(store, { url, mutationTypes: types.GET_PAYMENT_SESSION_ID })
        },
        isStoreDisabled(store) {
            let url = api.payment + 'IsStoreDisabled'
            return doAsyncGet(store, { url, mutationTypes: types.IS_STORE_DISABLED })
        },
        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default payment
